import { useMatch } from 'react-router';

import { AnalysisGuidedTour } from '../../modules/analysis/AnalysisGuidedTour.tsx';

export const GuidedTours = () => {
  const analysis = useMatch('order/:orderID/paired-cost/analysis');

  if (analysis) return <AnalysisGuidedTour />;

  return null;
};
